module.exports = __webpack_public_path__ + "img/didi-propa.3d892663.png";